import AwardableCompetenceList from './AwardableCompetenceList';
export default AwardableCompetenceList;